export default __webpack_public_path__ + "static/media/wom.ac5fc9a1.jpg";